import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as BranchActions from './Branchmaster.action';
import { catchError, map, mergeMap, of } from 'rxjs';
import { NSAdminbuysellRuleserviceService } from '../../Clients/NS/Services/NSAdminbuysellRuleservice.service';

@Injectable()
export class BranchEffects {
  constructor(
    private actions$: Actions,
    private buysellRuleservice: NSAdminbuysellRuleserviceService
  ) {}

  loadBranches$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BranchActions.GetBranch), // when GetBranch is dispatched
      mergeMap(() =>
        this.buysellRuleservice.GetBranchlist().pipe(
          map((branches) =>
            BranchActions.GetBranchSuccess({ GetBranchSuccess: branches })
          ),
          catchError((error) =>
            of(BranchActions.GetBranchFailed({ GetBranchFailed: error }))
          )
        )
      )
    )
  );
}
